/*
 * File: index.ts
 * File Created: 2023-12-19 12:56:12
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-09-17 10:34:38
 * Modified By: Val Liu
 * -----
 */

export * from "./core";

/// preload all the tags
((r) => r.keys().forEach(r))(require.context("./", true, /\.ts$/));
